/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import Shell from '../../common/components/Shell/Shell';
import DownloadDocController from '../../domain/myProfile/documents/DownloadDocs/DownloadDocController';
import DTONotification from './DTONotification';
import NotificationPresenter from './NotificationPresenter';
import { useTranslation } from 'react-i18next';
import { changeApplang } from '../../common/configs/utils';
import { getUpdateReadAt } from '../../common/configs/utils';
import { useAppSelector } from '../../infra/hooks';

function NotificationController() {
  const [notificationData, setnotificationData] = useState([]);
  const [textfilterData, setTextfilterData] = useState('');
  const [open_modal, setOpenModal] = useState(false);
  const [attachment, showAttachment] = useState('');
  const selector = useAppSelector((state) => state);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const newlang: any = localStorage.getItem('emplang');
    const _lang = newlang ? newlang : 'en';
    i18n.changeLanguage(_lang);
    changeApplang(_lang, false);
  }, []);
  function callBackFunc(data: any) {
    setnotificationData(data);
  }

  async function callBackTextfilter(Data: any) {
    setTextfilterData(Data);
  }
  const handleEmpAttachedDoc = (params: any) => {
    if (params?.row?.attachment != null) {
      setOpenModal(true);
      showAttachment(params?.row?.attachment);
    } else {
      toast.error(t('There is no Attachment!'));
    }
  };
  const UpdateReadAt = (data: any) => {
    const id = data?.row?.id;
    const table = data?.row?.datafrom;
    const emp_id = selector.authSlice.emp_id;
    getUpdateReadAt(id, table, emp_id);
  };
  return (
    <>
      <Shell>
        <Grid
          container
          style={{
            maxWidth: 'auto',
            marginLeft: '7.25em',
            marginTop: '1em',
          }}
        >
          <NotificationPresenter
            notificationData={notificationData}
            setTextFilterSearch={callBackTextfilter}
            trans={t}
            i18n={i18n}
            setEmpAttachedDoc={handleEmpAttachedDoc}
            calltoupdateread={UpdateReadAt}
          />
        </Grid>
      </Shell>
      <DTONotification
        setNotificationData={callBackFunc}
        settextFilter={textfilterData}
      />
      {open_modal && (
        <DownloadDocController
          isModalOpen={open_modal}
          closeModal={() => setOpenModal(false)}
          attachmentUrl={attachment}
        />
      )}
    </>
  );
}
export default NotificationController;
